import React from "react";
import "aos/dist/aos.css";
import { FaGithub, FaLinkedin, FaEnvelope, FaWhatsapp } from "react-icons/fa";
import { RiCodeSSlashLine } from "react-icons/ri";

const Footer = () => {
  const year = new Date().getFullYear();

  const socialLinks = [
    {
      icon: <FaGithub />,
      href: "https://github.com/leachouri",
      label: "GitHub",
      color: "hover:text-gray-800 dark:hover:text-gray-300"
    },
    {
      icon: <FaLinkedin />,
      href: "https://www.linkedin.com/in/leachouri",
      label: "LinkedIn",
      color: "hover:text-blue-600 dark:hover:text-blue-400"
    },
    {
      icon: <FaEnvelope />,
      href: "mailto:leachouri2019@gmail.com",
      label: "Email",
      color: "hover:text-red-600 dark:hover:text-red-400"
    },
    {
      icon: <FaWhatsapp />,
      href: "https://wa.me/212613891359",
      label: "WhatsApp",
      color: "hover:text-green-600 dark:hover:text-green-400"
    }
  ];

  return (
    <footer className="bg-white dark:bg-gray-700 transition-colors duration-300">
      <hr className="border-gray-300 dark:border-gray-600 border-1" />

      {/* Footer Content */}
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
          {/* About Section */}
          <div className="text-center md:text-left">
            <h3 className="text-xl font-bold text-black dark:text-white mb-4 flex items-center justify-center md:justify-start">
              <RiCodeSSlashLine className="mr-2 text-primaryColor dark:text-blue-400" />
              About
            </h3>
            <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
              Java Fullstack Developer & Software Engineer passionate about building
              scalable web applications and innovative solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center md:text-left">
            <h3 className="text-xl font-bold text-black dark:text-white mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#home"
                  className="text-gray-600 dark:text-gray-400 hover:text-primaryColor dark:hover:text-blue-400 transition-colors duration-300 text-sm"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="#experience"
                  className="text-gray-600 dark:text-gray-400 hover:text-primaryColor dark:hover:text-blue-400 transition-colors duration-300 text-sm"
                >
                  Experience
                </a>
              </li>
              <li>
                <a
                  href="#portfolio"
                  className="text-gray-600 dark:text-gray-400 hover:text-primaryColor dark:hover:text-blue-400 transition-colors duration-300 text-sm"
                >
                  Projects
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="text-gray-600 dark:text-gray-400 hover:text-primaryColor dark:hover:text-blue-400 transition-colors duration-300 text-sm"
                >
                  Contact
                </a>
              </li>
              {/* <li>
                <a
                  href="#admin"
                  className="text-gray-600 dark:text-gray-400 hover:text-primaryColor dark:hover:text-blue-400 transition-colors duration-300 text-sm"
                >
                  Admin Panel
                </a>
              </li> */}
            </ul>
          </div>

          {/* Social Links */}
          <div className="text-center md:text-left">
            <h3 className="text-xl font-bold text-black dark:text-white mb-4">Connect</h3>
            {/* <div className="flex justify-center md:justify-start gap-4">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`text-2xl text-gray-600 dark:text-gray-400 ${link.color} transition-all duration-300 transform hover:scale-110`}
                  aria-label={link.label}
                  title={link.label}
                >
                  {link.icon}
                </a>
              ))}
            </div> */}
            <div className="mt-4 text-sm text-gray-600 dark:text-gray-400">
              <p>leachouri2019@gmail.com</p>
              <p>+212 613891359</p>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-gray-300 dark:border-gray-600 pt-6 mt-6">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-gray-600 dark:text-gray-400 text-sm mb-4 md:mb-0">
              © {year} <span className="font-semibold text-black dark:text-white">Mohamed Leachouri</span>. All rights reserved.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`text-2xl text-gray-600 ml-4 dark:text-gray-400 ${link.color} transition-all duration-300 transform hover:scale-110`}
                  aria-label={link.label}
                  title={link.label}
                >
                  {link.icon}
                </a>
              ))}
              {/* <span>Built with</span>
              <span className="text-red-500 animate-pulse">❤️</span>
              <span>using React & Firebase</span> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
